import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './equipamentoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';

import { setModoTela, initForm, salvar, excluir, getLista, getListaTipo } from './equipamentoActions';
import { getLista as getListaUnidadeMedida } from '../unidadeMedida/unidadeMedidaActions';

const columns = [{
    field: 'nome',
    type: 'text'
}, {
    field: 'nome_tipo',
    type: 'text'
}, {
    field: 'capacidade',
    type: 'decimal'
}, {
    field: 'sigla_unidade_medida',
    type: 'text'
}];

class Equipamento extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'nome',
			direction: 'asc' // 'asc' | 'desc'
		}
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTipo();
		this.props.getListaUnidadeMedida();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.nome}
					${item.nome_tipo}
					${FormatUtils.formatarValorTela(item.capacidade, 2)}
					${item.sigla_unidade_medida}
				`.toUpperCase().includes(pesquisar)
				);
		}).map(item => ({
			...item,
			capacidade: FormatUtils.formatarValorTela(item.capacidade, 2)
		}));

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;

		const listaAux = this.filtrar();

		let lista = [];
		listaAux.forEach(item => {
			lista.push(item)
		});		

		let setLinhaSelecionada = (id) => {
			this.setState({
				...this.state,
				linhaSelecionada: id
			});
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<InputPesquisa
							cols='12 6 3 1'
							label='Pesquisar'
							minWidth={344}
							onChange={value => this.setState({ ...this.state, pesquisar: value })} />

						<div style={{ marginTop: 8, width: 270 }}>
							<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({ itens: [] });
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>
							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>
							<ExcelFile
								filename={'Equipamentos'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								{this.montarExcel(lista)}
							</ExcelFile>
						</div>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive border alturaFixa striped
						maxHeight={window.innerWidth < 631 ? window.innerHeight - 260 : window.innerHeight - 180}>
						<THead>
							<Tr>
								<ThSort
									field='nome'
									label='Nome'
									width={300}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='nome_tipo'
									label='Tipo'
									width={200}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='capacidade'
									label='Capacidade'
									width={100}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<ThSort
									field='sigla_unidade_medida'
									label='Unidade Medida'
									width={100}
									sort={this.state.sort}
									onSort={field => this.onSort(field)}
								/>

								<Th sticky alignCenter width={50}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => (
								<Tr key={i}
									backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.nome_tipo}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.capacidade}</Td>
									<Td onClick={() => setLinhaSelecionada(item.id)} alignCenter>{item.sigla_unidade_medida}</Td>
									<Td alignCenter minWidth={130} maxWidth={130}>
										<ButtonTable
											type={'warning'}
											width={32}
											small
											icon={'fas fa-pencil-alt'}
											visible={true}
											title='Editar'
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											width={32}
											small
											icon={'fas fa-trash-alt'}
											visible={true}
											title='Excluir'
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	montarExcel(lista) {

		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		return (
			<ExcelSheet data={lista.map(item => ({
				...item,
				quantidade: parseFloat(FormatUtils.formatarValorBanco(item.quantidade, 2))
			}))} name='Equipamentos'>
				{[
					{ componente: <ExcelColumn key={1} label='Código da Integração' value='codigo_integracao'/>},
					{ componente: <ExcelColumn key={2} label='Nome' value='nome'/>},
					{ componente: <ExcelColumn key={3} label='Tipo' value='nome_tipo'/>},
					{ componente: <ExcelColumn key={5} label='Capacidade' value='capacidade' type='number'/>},
					{ componente: <ExcelColumn key={6} label='Unidade de Medida' value='sigla_unidade_medida'/>},
					{ componente: <ExcelColumn key={11} label='Usuário da Inclusão' value='nome_usuario_inclusao'/>},
					{ componente: <ExcelColumn key={12} label='Usuário da Alteração' value='nome_usuario_alteequipamento'/>}
				].filter(item => {
					return true;
				}).map(item => (
					item.componente
				))}
			</ExcelSheet>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.equipamento.modoTela,
	aguardando: state.equipamento.aguardando,
	lista: state.equipamento.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, getListaTipo, getListaUnidadeMedida
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Equipamento);